import {SearchTitleDefaultBox} from "./search-title.default.box";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchTitleMrGreenMiniOrbitBox} from "./search-title-mr-green-mini-orbit.box";

export const SearchTitleBox = styledByTheme( SearchTitleDefaultBox).forMrGreenCis(SearchTitleMrGreenMiniOrbitBox).forMrGreenCip(SearchTitleMrGreenMiniOrbitBox).apply();